import { QUESTION_TYPES } from '@api/instant_survey';
import type { Question } from '@api/surveys/utilities/types';
import { getQuestionTypeIcon, getQuestionTypeName } from '@helpers';
import { Card, Layout, Pill } from '@utilities';

import { PreviewButton } from '../../../../../../components/SurveyPreview';

import styles from './_index.module.scss';

interface QuestionnaireProps {
  isPreviewButtonDisabled: boolean;
  onPreviewButtonClick: () => void;
  surveyQuestions: Question[];
}

const Questionnaire = ({
  isPreviewButtonDisabled,
  onPreviewButtonClick,
  surveyQuestions,
}: QuestionnaireProps) => {
  return (
    <div>
      <div className={styles['questionnaire-header']}>
        <h3>Questionnaire</h3>
        <PreviewButton
          isDisabled={isPreviewButtonDisabled}
          location="survey details"
          onClick={() => onPreviewButtonClick()}
        />
      </div>
      <Layout.Flex.Column as="ol" gap="small">
        {surveyQuestions?.map((question, index) => {
          const effectiveType = question?.turf ? QUESTION_TYPES.TURF.value : question?.type;
          const TypeIcon = getQuestionTypeIcon(effectiveType) as React.ReactNode;
          const typeName = getQuestionTypeName(effectiveType);
          return (
            <li key={question.id}>
              <Card as={Layout.Flex} className={styles['questionnaire-question']} elevation={1}>
                <div>
                  <strong>{index + 1}</strong>
                </div>
                <Layout.Flex.Column>
                  <Layout.Flex className={styles['questionnaire-question-body']} gap="small">
                    <Layout.Fill>{question.title}</Layout.Fill>
                    <div>
                      <Pill icon={TypeIcon} isCompleted value={typeName} />
                    </div>
                  </Layout.Flex>
                </Layout.Flex.Column>
              </Card>
            </li>
          );
        })}
        {surveyQuestions?.length === 0 && <p>No questions are assigned to this survey.</p>}
      </Layout.Flex.Column>
    </div>
  );
};

export default Questionnaire;
